<div *ngIf="showSettings">
  <mat-card class="example-card biggest-container">
    <mat-card-content>
      <mat-toolbar
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        color="primary"
        >Paramétres
      </mat-toolbar>

      <ng-template #attente>
        <br />
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
    </mat-card-content>
  </mat-card>
  <div class="padding" *ngIf="!startLoading; else attente">
    <div class="display">
      <div class="width70">
        <form
          [formGroup]="objectThemeForm"
          (ngSubmit)="onSubmit()"
          style="
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 0 1rem;
          "
        >
          <div *ngFor="let key of objectThemeForm?.controls | keyvalue">
            <ng-container *ngIf="isArrayControl(key.key, key); else inputField">
              <div
                [formGroupName]="key.key"
                style="
                  border: 1px solid #ccc;
                  padding: 10px;
                  margin-bottom: 10px;
                "
              >
                <h4>{{ key.key }} (List)</h4>
                <div
                  *ngFor="let item of key.value.controls; let i = index"
                  [formGroupName]="i"
                  style="
                    border: 1px solid #ccc;
                    padding: 10px;
                    margin-bottom: 10px;
                  "
                >
                  <div *ngFor="let subKey of item.controls | keyvalue">
                    <!-- If the control value length is less than or equal to 100, render an input field -->
                    <mat-form-field
                      *ngIf="
                        !checkLength(subKey.key, key.key, i) &&
                        getInputType(subKey.key, key.key) !== 'checkbox'
                      "
                      style="width: 100%"
                    >
                      <input
                        matInput
                        [formControlName]="subKey.key"
                        id="{{ subKey.key }}"
                        [type]="getInputType(subKey.key, key.key)"
                        [placeholder]="subKey.key"
                      />
                    </mat-form-field>

                    <!-- If the control value length is greater than 100, render a textarea -->
                    <mat-form-field
                      *ngIf="
                        checkLength(subKey.key, key.key, i) &&
                        getInputType(subKey.key, key.key) !== 'checkbox'
                      "
                      style="width: 100%"
                    >
                      <textarea
                        matInput
                        [formControlName]="subKey.key"
                        id="{{ subKey.key }}"
                        [placeholder]="subKey.key"
                      ></textarea>
                    </mat-form-field>

                    <!-- Checkbox logic remains the same -->
                    <mat-checkbox
                      *ngIf="getInputType(subKey.key, key.key) === 'checkbox'"
                      [formControlName]="subKey.key"
                    >
                      {{ subKey.key }}
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-template
              #inputField
              *ngIf="isFormGroup(objectThemeForm.get(key.key)); else nonGroup"
            >
              <div
                [formGroupName]="key.key"
                style="
                  border: 1px solid #ccc;
                  padding: 10px;
                  margin-bottom: 10px;
                "
              >
                <h4>{{ key.key }} (Composé)</h4>
                <div
                  *ngFor="
                    let subKey of objectThemeForm.get(key.key).controls
                      | keyvalue
                  "
                >
                  <ng-container>
                    <mat-form-field
                      *ngIf="getInputType(subKey.key, key.key) !== 'checkbox'"
                      style="width: 100%"
                    >
                      <input
                        matInput
                        [formControlName]="subKey.key"
                        id="{{ subKey.key }}"
                        [type]="getInputType(subKey.key, key.key)"
                        [placeholder]="subKey.key"
                        [disabled]="subKey.key === 'name_website'"
                      />
                    </mat-form-field>
                    <mat-checkbox
                      *ngIf="getInputType(subKey.key, key.key) === 'checkbox'"
                      [formControlName]="subKey.key"
                    >
                      {{ subKey.key }}
                    </mat-checkbox>
                  </ng-container>
                </div>
              </div>
            </ng-template>

            <ng-template #nonGroup>
              <ng-container *ngIf="checkInputsBeforeGenerate(key.key)">
                <mat-form-field
                  style="width: 100%"
                  *ngIf="getInputType(key.key) !== 'checkbox'"
                >
                  <input
                    matInput
                    [formControlName]="key.key"
                    id="{{ key.key }}"
                    [type]="getInputType(key.key)"
                    [placeholder]="key.key"
                    [disabled]="key.key === 'name_website'"
                  />
                </mat-form-field>
                <mat-checkbox
                  *ngIf="getInputType(key.key) === 'checkbox'"
                  [formControlName]="key.key"
                >
                  {{ key.key }}
                </mat-checkbox>
              </ng-container>
            </ng-template>
          </div>

          <button
            mat-raised-button
            type="submit"
            class="colorBlue positionButton"
          >
            Enregistrer
          </button>
        </form>
      </div>
      <div class="width30">
        <div style="border-top: 10px; border-color: gray; margin-top: 1rem">
          <div>
            <h2 class="title">Ajouter un nouveau Champ</h2>
          </div>
          <mat-form-field style="margin-right: 10px; width: 100%">
            <input
              matInput
              id="newAttributeKey"
              [(ngModel)]="newAttributeKey"
              placeholder="Nom"
            />
          </mat-form-field>
          <mat-form-field style="margin-right: 10px; width: 100%">
            <input
              matInput
              id="newAttributeValue"
              [(ngModel)]="newAttributeValue"
              placeholder="Valeur"
            />
          </mat-form-field>
          <!-- Button to add new attribute -->
          <button
            mat-raised-button
            type="button"
            (click)="addNewAttribute()"
            class="colorBlue"
            style="width: 100%"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-access-to-settings
  *ngIf="!showSettings"
  (afterVerifAcess)="init()"
></app-access-to-settings>
